// Normalize an axios/FastAPI error into a safe, human-readable string.
// FastAPI validation (422) returns `detail` as an array of objects, which
// must never be passed directly to React state / JSX.
export function formatApiError(err, fallback = 'Something went wrong') {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) {
    return d.map((x) => x?.msg || (typeof x === 'string' ? x : JSON.stringify(x))).join(', ');
  }
  if (d && typeof d === 'object') return d.msg || JSON.stringify(d);
  return err?.message || fallback;
}
